export default __webpack_public_path__ + "static/media/sofia-pro-semibold.923f4975.woff2";